<app-header></app-header>

<div class="main-container d-flex">
  <app-sidebar></app-sidebar>

  <div class="container-fluid h-100p overflow-y-scroll feedback-main px-2 px-sm-3 px-lg-4">
    <div class="feedback-page">
      <header class="feedback-hero">
        <h1 class="feedback-page-title">Feedback</h1>
        <p class="feedback-page-subtitle">
          Share suggestions, report issues, or attach images, voice recordings, and videos.
          Your input directly shapes the next release.
        </p>
      </header>

      <div class="feedback-card">
        <!-- 1. Rating -->
        <section class="form-step">
          <div class="step-header">
            <span class="step-num">1</span>
            <div class="step-title-row">
              <h3 class="step-title">
                How was your experience?
                <span class="required-mark">*</span>
              </h3>
              <span
                class="step-hint rating-label"
                [class.rating-label-active]="activeRatingValue > 0"
              >
                {{ ratingLabelText }}
              </span>
            </div>
          </div>
          <div
            class="star-rating"
            role="radiogroup"
            aria-label="Rate your experience from 1 to 5 stars"
            (mouseleave)="onStarLeave()"
          >
            <button
              *ngFor="let star of [1, 2, 3, 4, 5]"
              type="button"
              class="star-btn"
              [class.active]="isStarActive(star)"
              [attr.aria-label]="star + ' star' + (star > 1 ? 's' : '')"
              [attr.aria-pressed]="rating === star"
              [disabled]="isLoading"
              (click)="setRating(star)"
              (mouseenter)="onStarHover(star)"
            >
              <i class="bi" [ngClass]="isStarActive(star) ? 'bi-star-fill' : 'bi-star'"></i>
            </button>
          </div>
        </section>

        <!-- 2. Feedback type -->
        <section class="form-step">
          <div class="step-header">
            <span class="step-num">2</span>
            <h3 class="step-title">What kind of feedback?</h3>
          </div>
          <div class="type-grid">
            <button
              *ngFor="let type of feedbackTypes"
              type="button"
              class="type-card"
              [class.selected]="feedbackType === type.value"
              [disabled]="isLoading"
              (click)="setFeedbackType(type.value)"
            >
              <span class="type-label">{{ type.label }}</span>
              <span class="type-desc">{{ type.description }}</span>
            </button>
          </div>
        </section>

        <!-- 3. Message -->
        <section class="form-step">
          <div class="step-header">
            <span class="step-num">3</span>
            <div class="step-title-row">
              <h3 class="step-title">
                Your message
                <span class="required-mark">*</span>
              </h3>
              <span class="char-count">{{ charactersLeft }} characters left</span>
            </div>
          </div>
          <textarea
            id="feedbackMessage"
            class="feedback-message-input"
            [(ngModel)]="message"
            [maxlength]="maxMessageLength"
            rows="5"
            placeholder="Tell us what happened, what you'd like to see, or what worked well..."
            [disabled]="isLoading"
          ></textarea>
        </section>

        <!-- 4. Attachments -->
        <section class="form-step">
          <div class="step-header">
            <span class="step-num">4</span>
            <div class="step-title-row">
              <h3 class="step-title">Attachments</h3>
              <span class="step-hint">Optional — drop files or click to upload</span>
            </div>
          </div>

          <div class="upload-row">
            <div class="upload-box">
              <div class="upload-title">Images</div>
              <label class="upload-btn" for="imagesInput" role="button">
                <i class="bi bi-upload"></i>
                Upload
                <input
                  id="imagesInput"
                  hidden
                  type="file"
                  multiple
                  accept="image/*"
                  (change)="onImagesSelected($event)"
                />
              </label>
              <div class="upload-hint">JPEG, PNG, WEBP, GIF · Max 10</div>
            </div>

            <!-- Voice / Audio temporarily disabled
            <div class="upload-box">
              <div class="upload-title">Voice / Audio</div>
              <div class="audio-actions">
              <label class="upload-btn" for="audioInput" role="button">
                <i class="bi bi-upload"></i>
                Upload
                <input
                  id="audioInput"
                  hidden
                  type="file"
                  multiple
                  accept="audio/*"
                  (change)="onAudioSelected($event)"
                  [disabled]="isLoading"
                />
              </label>
                <button
                  type="button"
                  class="record-btn"
                  [class.recording]="isRecording"
                  [disabled]="isLoading"
                  (click)="isRecording ? stopRecording() : startRecording()"
                >
                  <i class="bi" [ngClass]="isRecording ? 'bi-stop-fill' : 'bi-mic-fill'"></i>
                  {{ isRecording ? 'Stop' : 'Record' }}
                </button>
              </div>
              <div class="recording-status" *ngIf="isRecording">
                <span class="rec-dot"></span>
                Recording {{ formatRecordingTime() }}
              </div>
              <div class="upload-hint">MP3, WAV, OGG, WEBM · Max 5</div>
            </div>
            -->

            <div class="upload-box">
              <div class="upload-title">Video</div>
              <label class="upload-btn" for="videoInput" role="button">
                <i class="bi bi-upload"></i>
                Upload
                <input
                  id="videoInput"
                  hidden
                  type="file"
                  multiple
                  accept="video/*"
                  (change)="onVideoSelected($event)"
                />
              </label>
              <div class="upload-hint">MP4, WEBM, MKV, MOV · Max 5</div>
            </div>
          </div>

          <div *ngIf="attachments.length > 0" class="preview-list">
            <div class="attachment-grid">
              <div class="attachment-item" *ngFor="let a of attachments; let i = index">
                <button
                  type="button"
                  class="remove-btn"
                  (click)="removeAttachment(i)"
                  [disabled]="isLoading"
                  aria-label="Remove attachment"
                >
                  <i class="bi bi-x-lg"></i>
                </button>
                <div class="attachment-kind">{{ a.kind | titlecase }}</div>
                <div class="attachment-name">{{ a.file.name }}</div>
                <img
                  *ngIf="a.kind === 'image'"
                  class="attachment-thumb"
                  [src]="a.previewUrl"
                  alt="Selected image"
                />
                <!-- Voice / Audio preview temporarily disabled
                <audio
                  *ngIf="a.kind === 'audio'"
                  class="attachment-audio"
                  [src]="a.previewUrl"
                  controls
                ></audio>
                -->
                <video
                  *ngIf="a.kind === 'video'"
                  class="attachment-video"
                  [src]="a.previewUrl"
                  controls
                ></video>
              </div>
            </div>
          </div>
        </section>

        <!-- 5. Reply email -->
        <section class="form-step">
          <div class="step-header">
            <span class="step-num">5</span>
            <div class="step-title-row">
              <h3 class="step-title">Email</h3>
              <span class="step-hint">Optional</span>
            </div>
          </div>
          <input
            id="replyEmail"
            type="email"
            class="feedback-email-input"
            [(ngModel)]="replyEmail"
            placeholder="you@company.com"
            [disabled]="isLoading"
          />
        </section>

        <footer class="form-footer">
          <p class="disclaimer">
            By submitting you agree to share diagnostic context with the RYNO team.
            We never share your feedback publicly.
          </p>
          <button class="submit-btn" type="button" (click)="submit()" [disabled]="isLoading">
            <i class="bi bi-send-fill"></i>
            {{ isLoading ? 'Submitting...' : 'Submit feedback' }}
          </button>
        </footer>
      </div>
    </div>

    <app-overlay-loader [show]="isLoading"></app-overlay-loader>
  </div>
</div>
